module.exports = __webpack_public_path__ + "static/media/nu.1db5a99d.svg";